import appConfig from '@/config/app'

class assetHelper {
  static getImageUrl (path) {
    return `${appConfig.apiBaseUrl}/${path}`
  }
}

export default assetHelper
